import React, { useContext, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import { Timeline, TimelineSeparator, TimelineContent, TimelineDot } from '@mui/lab';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import { Box, Grid, Stack, Typography, FormControl, Select, MenuItem } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { RiDeleteBin5Line } from 'react-icons/ri';
import SearchActivites from '../../../../../../Networks/Components/Resuable/SearchActivity';
import ProfilePic from '../../../../../../../components/Common/ProfilePic';
import { LanguageContext } from '../../../../../../../libs/Context';
import penEditIcon from '../../../../../../../assets/SvgIcons/resources/PenEdit.svg';
import TogglesIcon from '../../../../../../../assets/Resources/toggles.svg';
import { HiOutlinePencil } from 'react-icons/hi';

const activities = [
	{
		date  : 'Today',
		items : [
			{
				id          : 1,
				type        : 'Created a new category',
				catName     : 'Interactive Devices',
				isSender    : true,
				name        : 'John Doe',
				time        : '10:30 AM',
				icon        : penEditIcon,
				iconType    : 'img',
				circleColor : '#4CAF50'

			},
			{
				id          : 2,
				type        : 'accepted',
				catName     : 'Mobiles AI Specs ',
				subcatName  : 'AI-Based App Suggestions',
				isSender    : false,
				name        : 'Jane Smith',
				time        : '11:45 AM',
				icon        : penEditIcon,
				iconType    : 'img',
				circleColor : '#4CAF50',
				to          : 'Under'

			},
			{
				id          : 3,
				type        : 'Uploaded a new video',
				catName     : 'Digital Marketing Tips',
				subcatName  : 'Mobiles AI Specs',
				isSender    : false,
				name        : 'Jane Smith',
				time        : '11:45 AM',
				icon        : penEditIcon,
				iconType    : 'img',
				circleColor : '#4CAF50',
				to          : 'to'

			}
		]
	},
	{
		date  : ' Yesterday',
		items : [
			{
				id          : 4,
				type        : 'Uploaded new video  ',
				catName     : 'The Future of Gaming',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : <HiOutlinePencil style={{ color: '#fff' }} fontSize={20} />,
				iconType    : 'icon',
				circleColor : '#3882E4'

			},
			{
				id          : 5,
				type        : 'Uploaded new video ',
				catName     : 'The Future of Gaming',
				subcatName  : 'Mobiles AI Specs',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : penEditIcon,
				iconType    : 'img',
				circleColor : '#4CAF50',
				to          : 'as'

			},
			{
				id          : 6,
				type        : 'AI Innovations',
				catName     : 'AI Innovations',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : TogglesIcon,
				iconType    : 'img',
				circleColor : '#FF9800'
			},
			{
				id          : 7,
				type        : 'AI Innovations',
				catName     : 'AI Innovations',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : TogglesIcon,
				iconType    : 'img',
				circleColor : '#9C27B0'
			}
		]
	},
	{
		date  : '11 Aug 2024',
		items : [
			{
				id          : 8,
				type        : 'connection request',
				catName     : 'Interactive Devices',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : <HiOutlinePencil style={{ color: '#fff' }} fontSize={20} />,
				iconType    : 'icon',
				circleColor : '#3882E4'
			},
			{
				id          : 9,
				type        : 'Deleted the article Top 5 new AI tools of 2024',
				catName     : 'Programming Basics',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : <RiDeleteBin5Line style={{ color: '#fff' }} fontSize={20} />,
				iconType    : 'icon',
				circleColor : '#F44336',
				to          : 'in'
			},
			{
				id          : 10,
				type        : 'connection request',
				catName     : 'Interactive Devices',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : penEditIcon,
				iconType    : 'img',
				circleColor : '#4CAF50'

			},
			{
				id          : 11,
				type        : 'connection request',
				catName     : 'Interactive Devices',
				isSender    : false,
				name        : 'Mike Johnson',
				time        : '3:20 PM',
				icon        : TogglesIcon,
				iconType    : 'img',
				circleColor : '#FF9800'

			}
		]
	}
];
const filterOptions = [ 'All', 'Categories', 'Subcategories', 'Article', 'Video', 'Podcast', 'Image', 'Documents', 'Playlist' ];
const ResourceActivitySlider = ({ open, handleClose }) =>
{
	const [ filterItems, setFilterItems ] = useState('All');
	const { language } = useContext(LanguageContext);

	const handleFilterChange = (event) =>
	{
		setFilterItems(event.target.value);
	};
	const handleUpdateInd = (type) =>
	{
		const allMatches = document.querySelectorAll('[id^="search-"]');

		if (!allMatches.length) return;
		const currentIndex = Array.from(allMatches).findIndex((ele) =>
		{
			return ele instanceof HTMLElement && ele.style.backgroundColor === 'brown';
		});
		let newIndex = type === 'increase'
			? currentIndex + 1
			: currentIndex - 1;

		if (newIndex >= allMatches.length) newIndex = 0;
		if (newIndex < 0) newIndex = allMatches.length - 1;

		const newElement = allMatches[newIndex];

		if (newElement instanceof HTMLElement)
		{
			newElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
			newElement.style.backgroundColor = 'brown';
			allMatches.forEach((ele) =>
			{
				if (ele !== newElement && ele instanceof HTMLElement)
				{
					ele.style.backgroundColor = 'yellow';
				}
			});
		}
	};

	return (
		<Drawer
			open={open}
			onClose={handleClose}
			anchor='right'
			PaperProps={{
				sx : {
					width         : { xs: '100%', sm: '70%', md: '50%', lg: '40%' },
					display       : 'flex',
					flexDirection : 'column'
				}
			}}
		>
			<Grid container>
				<Grid
					item
					container
					display='flex'
					p={2}
					justifyContent='space-between'
					alignItems='center'
					sx={{ backgroundColor: '#f2f2f2', position: 'sticky', top: 0, zIndex: 1 }}
				>
					<Grid item>
						<Typography fontSize={18} fontWeight={500}>{language?.activity}</Typography>
					</Grid>
					<Grid item onClick={handleClose} sx={{ cursor: 'pointer' }}>
						<Close />
					</Grid>
				</Grid>

				<Grid item container px={3} py={2}>
					{activities.map((dateGroup, Idvalue) => (
						<Grid item xs={12} key={dateGroup.date}>
							<Stack direction='row' alignItems='center' justifyContent='space-between'>
								<Typography variant='inherit' sx={{ mb: 2 }} fontWeight='var(--font500)' lineHeight={0.9} minWidth='20%'>
									{dateGroup.date}
								</Typography>
								{Idvalue === 0 &&
								<Stack direction='row' alignItems='center' spacing={1}>
									<SearchActivites
										handleUpdateInd={handleUpdateInd}
									/>
									{filterItems?.length > 0 &&
									<FormControl sx={{ minWidth: 120, maxHeight: 200 }} size='small'>
										<Select
											labelId='demo-select-small-label'
											id='demo-select-small'
											placeholder='Age'
											value={filterItems}
											onChange={handleFilterChange}
											className='capitalTxt'
											size='small'
										>
											{filterOptions?.map((value) => (
												<MenuItem className='capitalTxt' key={value} value={value}>
													{value}
												</MenuItem>
											))}
										</Select>
									</FormControl>
									}
								</Stack>}
							</Stack>

							<Timeline
								sx={{
									[`& .${timelineItemClasses.root}:before`] : { flex: 0, padding: 0 },
									padding                                   : '16px 0px'
								}}
							>
								{dateGroup.items.map((activity, index) => (
									<TimelineItem key={activity.id}>
										<TimelineSeparator>
											<TimelineDot
												sx={{
													width          : 40,
													height         : 40,
													background     : `${activity.circleColor}`,
													color          : '#fff',
													display        : 'flex',
													alignItems     : 'center',
													justifyContent : 'center',
													margin         : '2px 0px'
												}}
											>
												{activity.iconType === 'img'
													?																								(
														<Box component={'img'}
															src={typeof activity.icon === 'string' ? activity.icon : ''}
															sx={{ height: '24px', width: '22px', borderRadius: '50%' }}
														/>
													)
													:																								(
														<Box width={24} height={24} display='flex' alignItems='center' justifyContent='center'>
															{activity.icon}
														</Box>
													)
												}
											</TimelineDot>

											{index < dateGroup.items.length - 1 && (
												<TimelineConnector
													sx={{
														borderStyle      : 'dashed',
														borderWidth      : '2px',
														borderTopWidth   : '0px',
														borderBottom     : '0px',
														borderRightWidth : '0px',
														borderColor      : '#bdbdbd',
														backgroundColor  : 'transparent'
													}}
												/>
											)}
										</TimelineSeparator>
										<TimelineContent sx={{ py: 0, px: 2 }}>
											<Stack direction='column'>
												<Box
													color='#737373'
													display='flex'
													flexWrap='wrap'
													alignItems='center'
													gap={0.5}
													width='100%'
												>
													<Typography variant='inherit' color='#737373' minWidth='fit-content' display='inline'>
														{activity.type}
													</Typography>
													<Typography
														variant='inherit'
														color='#23A4C4'
														sx={{
															whiteSpace   : 'nowrap',
															overflow     : 'hidden',
															textOverflow : 'ellipsis',
															display      : 'inline',
															maxWidth     : '180px',
															flexShrink   : 1,
															cursor       : 'pointer'
														}}
													>
														{activity.catName}
													</Typography>
													<Box sx={{ textTransform: 'lowercase !important' }}>{activity.to}</Box>
													{activity.subcatName && (
														<Typography
															variant='inherit'
															color='#23A4C4'
															sx={{
																display      : 'block',
																width        : '100%',
																overflow     : 'hidden',
																textOverflow : 'ellipsis',
																whiteSpace   : 'normal'
															}}
														>
															{activity.subcatName}
														</Typography>
													)}
												</Box>

												<Stack direction='row' spacing={1} alignItems='center'>
													<Box display='flex' alignItems='baseline'>
														<ProfilePic
															imagePath={''}
															defaultImg={'/images/logos/no_logo.png'}
															alt='profilepic'
															className='brdrRadius50 avatarPic20'
															width='auto'
														/>
														<Typography variant='caption' color='#23A4C4' pt={'4px'} pl={0.5}
															sx={{
																whiteSpace   : 'nowrap',
																overflow     : 'hidden',
																textOverflow : 'ellipsis',
																width        : 'var(--percent100)'
																// lineHeight   : 1.2
															}}
														>
															{activity.name}
														</Typography>
													</Box>
													<Box sx={{ height: '16px', width: '1px', backgroundColor: '#D5D5D5', alignSelf: 'center' }} />
													<Typography variant='caption' color='#666' pt={'4px'}>
														{activity.time}
													</Typography>
												</Stack>
											</Stack>

										</TimelineContent>
									</TimelineItem>
								))}
							</Timeline>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Drawer>
	);
};

export default ResourceActivitySlider;
